var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.592,
    height: 13.592,
    viewBox: "0 0 13.592 13.592",
    fill: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "error_black_24dp",
    d: "M8.8,2a6.8,6.8,0,1,0,6.8,6.8A6.8,6.8,0,0,0,8.8,2Zm0,7.475a.682.682,0,0,1-.68-.68V6.078a.68.68,0,1,1,1.359,0V8.8A.682.682,0,0,1,8.8,9.475Zm.68,2.718H8.116V10.835H9.475Z",
    transform: "translate(-2 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.11f813e1bae4d89091258954227acf15.svg";
export { ForwardRef as ReactComponent };